import { useQuery } from '@tanstack/react-query';
import { API_CLIENT } from '../api-new';

export const useUser = () => {
  return useQuery({
    queryKey: ['user'],
    queryFn: () => API_CLIENT.read_current_user(),
  });
};
